<c-toaster [placement]="notificationService.position" class="p-3" position="fixed">
  <c-toast
    (timer)="notificationService.onTimerChange($event)"
    (visibleChange)="notificationService.onVisibleChange($event)"
    [visible]="notificationService.visible()"
    [delay]="notificationService.delay"
  >
    <c-toast-header
      [ngClass]="{
        'toast-success': notificationService.toastType === 'success',
        'toast-error': notificationService.toastType === 'error',
        'toast-warning': notificationService.toastType === 'warning',
        'toast-tridimo': notificationService.toastType === 'tridimo'
      }"
    >
      {{ notificationService.toastHeader }}
    </c-toast-header>

    <c-toast-body>
      <p>{{ notificationService.toastContent }}</p>
    </c-toast-body>
  </c-toast>
</c-toaster>